<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="score-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <!-- 积分获取查询 -->
                    <h5 class="title"></h5>

                    <div class="data-view">
                        <div class="score-detail">
                            <div class="score-header">
                                <div class="td time">时间</div>
                                <div class="td amount">获取积分</div>
                            </div>

                            <vuescroll v-if="record_list.length">
                                <div class="list-view">
                                    <ul>
                                        <li v-for="(item,index) in record_list" :key="index">
                                            <div class="table-item time">{{ item.createTime }}</div>
                                            <div class="table-item amount">{{ item.socre }}</div>
                                        </li>
                                    </ul>   
                                </div>
                            </vuescroll>

                            <div class="notice" v-else>暂无积分获取记录</div>
                        </div>                        
                    </div>

                    <div class="u-btn ok" @click="destroyElement()"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
    .score-modal{
        position: relative;
        width: 625px;
        height: 470px;
        background-image: url(~@/assets/images/modal/bg-modal-score.png);        
    }

    .title{
        width: 516px;
        height: 51px;
        margin: 0 auto 36px;
        background-image: url(~@/assets/images/modal/title-score.png);      
    }

    .score-detail{
        margin-bottom: 12px;
        padding: 0 36px;

        .time{
            width: 310px;
        }

        .amount{
            width: 210px;
        }

        .notice{
            margin-top: 80px;
            text-align: center;
        }

        .list-view{
            height: 270px;
        }

        ul{
            padding: 0 15px;
            background-color: #f8f7f3;
            border: 1px solid #f8f7f3;

            li{
                display: flex;
                justify-content: space-between;
                text-align: center;

                .table-item{
                    padding: 12px 0;
                    border-bottom: 1px solid #f8f7f3;
                }
            }
        }
    }

    .score-header{
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        font-weight: 700;
        color: #696560;
        text-align: center;
    }
</style>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            record_list : [],        
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.render();
    }, 
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        render (){
            this.$get(ajax_url_map.record_score,{
                success : (data) => {
                    this.record_list = data.data.list.filter((ele)=>{
                        return ele.isPlus == true;
                    });
                }
            },{
                isPlus : true,
            })
        },           
    },
}
</script>